<template>
	<v-row align="center" no-gutters>
		<v-col>
			<v-alert
					class="customVAlert caption"
					min-height="75px"
					text
					v-html="$store.state.admin.input[inputItemKey]" />
		</v-col>
		<v-col class="ml-2" cols="auto">
			<v-dialog
					v-model="showDialog_"
					persistent
					width="50vw">
				<template v-slot:activator="{ on }">
					<v-btn	class="customVBtn"
							icon
							@click="$_admnTxtrMd_open(on)">
						<v-icon>edit</v-icon>
					</v-btn>
				</template>
				<v-card>
					<validation-observer ref="observerTextareaMarkdown" v-slot="validation">
						<v-card-text>
							<v-row class="px-2" no-gutters>
								<v-col>
									<validation-provider
											:name="'AdminTextareaMarkdown-' + contentKey + '-' + inputItemKey"
											:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
											mode="lazy"
											v-slot="{ errors }">
										<v-textarea
												v-model="markdown_"
												auto-grow
												:error-messages="errors" />
									</validation-provider>
								</v-col>
								<v-col class="center" cols="auto">
									<v-btn	class="customVBtn"
											icon
											@click="openLink({ url: 'https://colab.research.google.com/drive/11-Ks7-epfw_oIOaFKDpsCT1BUze-yMoQ' })">
										<v-icon>developer_mode</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions>
							<v-row dense justify="center">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:disabled="!validation.passed && !validation.valid"
											@click="$_admnTxtrMd_save()">Save</v-btn>
								</v-col>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											@click="$_admnTxtrMd_close()">Close</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</validation-observer>
				</v-card>
			</v-dialog>
		</v-col>
		<v-col class="ml-2" cols="auto">
			<clipboard-button :text="$store.state.admin.input[inputItemKey]" />
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: 'AdminTextareaMarkdown',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		data() {
			return {
				showDialog_: false,

				markdown_: null
			}
		},
		methods: {
			$_admnTxtrMd_open() {
				const self_ = this;
				const refs_ = self_.$refs;

				const input_ = self_.getAdminState('input')

				self_.markdown_ = input_[self_.inputItemKey]

				self_.showDialog_ = true;

				if(!self_.isFalse(refs_.observerTextareaMarkdown)) {
					refs_.observerTextareaMarkdown.reset()
				}
			},
			$_admnTxtrMd_save() {
				const self_ = this;

				const html_ = self_.marked(self_.markdown_)

				let input_ = self_.getAdminState('input')
				input_[self_.inputItemKey] = html_;

				self_.setAdminState('input', input_)

				self_.$_admnTxtrMd_close()
			},
			$_admnTxtrMd_close() {
				const self_ = this;

				self_.showDialog_ = false;
			}
		}
	}
</script>

<style scoped>
</style>
